import { Link } from "react-router-dom";
import { Compass, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-emerald-50 via-white to-green-50 px-4">
      {/* Animated background orbs */}
      <div className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-emerald-400/20 blur-3xl animate-pulse" />
      <div className="pointer-events-none absolute -bottom-40 -right-24 h-[28rem] w-[28rem] rounded-full bg-green-400/20 blur-3xl animate-pulse delay-1000" />
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[30rem] w-[30rem] rounded-full bg-emerald-300/10 blur-3xl" />

      <div className="relative z-10 flex flex-col items-center text-center">
        {/* 404 Number */}
        <div className="relative mb-6">
          <div className="flex h-28 w-28 items-center justify-center rounded-full bg-white/80 backdrop-blur-sm border border-emerald-100 shadow-2xl shadow-emerald-500/20">
            <span className="text-5xl font-bold bg-gradient-to-r from-emerald-500 to-green-600 bg-clip-text text-transparent">
              404
            </span>
          </div>
        </div>

        {/* Icon */}
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-emerald-500 to-green-600 shadow-lg shadow-emerald-500/30 mb-4">
          <Compass size={24} className="text-white" />
        </div>

        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Page Not Found
        </h1>
        
        <p className="text-sm text-gray-500 max-w-sm mb-6">
          The page you're looking for doesn't exist or may have moved.
        </p>

        {/* Go Back Button */}
        <button
          onClick={() => window.history.back()}
          className="flex items-center gap-2 px-6 py-2.5 bg-gradient-to-r from-emerald-500 to-green-600 text-white font-medium rounded-xl shadow-lg shadow-emerald-500/25 hover:shadow-emerald-500/40 hover:scale-[1.02] transition-all duration-200"
        >
          <ArrowLeft size={16} />
          Go Back
        </button>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-10px) rotate(5deg); }
        }
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}